module.exports = __webpack_public_path__ + "assets/images/50Box.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/50Box.png
// module id = 1302
// module chunks = 1